import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-check',
  templateUrl: './check.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckComponent { }
